/**
 * Created by jeffjing on 2016/11/22.
 */
import AlloyReport from '@tencent/alloy_report';
import { assign, getPlatform } from 'js/common/utils';
import value from 'js/common/value';

let platform = getPlatform();
let platformTdbank = {
    pc: 101,
    android: 102,
    ios: 103,
}[platform];

/**
 * 默认的tdbank字段
 */
const defaultTdbankConfig = {
    // 基础字段
    uin: value.uin,
    platform: platformTdbank, // 101：web_pc、102：web_android、103：web_ios
    qqversion: window.mqq && window.mqq.QQVersion,
    ts: Date.now(),
    // tdbank的id字段
    tdbank_busi_id: 'b_sng_now_group_video_base',
    tdbank_table: 'group_video_base',
    opername: 'group_video',
    roomid: value.roomId,
};

AlloyReport && AlloyReport.tdw.setDefaultTable('dc00141');
// 上报默认属性
AlloyReport &&
    AlloyReport.tdw.setDefaultData({
        // opername: 'Grp_robot',
        // obj1: value.gc,
        // obj2: mqq.QQVersion
    });

// 注意，不要改这里的reportMap，需要各个页面自己使用setReportConfig来设置上报的配置
const reportMap = {
    // 'example': {
    //     monitor: 123456,
    //     tdw: {
    //         module: 'sub_page',
    //         action: 'joke_open',
    //         ver1: 0
    //     },
    //     tdbank: {
    //
    //     }
    // }
};

/*
 汇总上报，包括 monitor/ tdw/ tdbank
 obj 可以是 {tdw: {tdwConfig}, tdbank: {tdbankConfig}} 形式，
 也可以在只有tdw或tdbank情况下直接写 {tdwConfig} 或 {tdbankConfig}
 */
export function report(key, config = {}) {
    var item;
    if (typeof key === 'string') {
        item = reportMap[key];
    } else {
        // 支持一下不带key的直接上报，仅做临时上报用，不推荐。 example: report({monitor: 1111, tdw:{action:'111'}})
        item = key;
    }

    if (!item) return;
    var immediately = item.immediately; // 是否立即上报

    if (item.monitor) {
        AlloyReport && AlloyReport.monitor(item.monitor, immediately);
    }

    if (item.tdw || config.tdw) {
        AlloyReport &&
            AlloyReport.tdw(assign({}, item.tdw, config.tdw), immediately); // 和预定义字段合并
    }

    if (item.tdbank || config.tdbank) {
        // console.error(assign({}, defaultTdbankConfig, item.tdbank, config.tdbank));
        AlloyReport &&
            AlloyReport.tdbank(
                assign({}, defaultTdbankConfig, item.tdbank, config.tdbank),
                immediately
            );
    }
}

/* 配置report */
export function setReportConfig(config) {
    if (config.tdw) {
        if (config.tdw.defaultTable) {
            AlloyReport &&
                AlloyReport.tdw.setDefaultTable(config.tdw.defaultTable);
        }
        if (config.tdw.defaultData) {
            AlloyReport &&
                AlloyReport.tdw.setDefaultData(config.tdw.defaultData);
        }
    }

    if (config.tdbank) {
        assign(defaultTdbankConfig, config.tdbank);
    }

    if (config.reportMap) {
        assign(reportMap, config.reportMap);
    }
}

export function reportRetCode(res, url, startTime) {
    var code = res.retcode || 0;
    var time = new Date() - startTime;

    AlloyReport &&
        AlloyReport.retcode({
            type: code === 0 ? 1 : 2,
            url: url.split('?')[0],
            code: code,
            time: time,
        });
}

/**
 * 上报tdbank，封装了基础字段，如果传入字段和基础字段相同会进行覆盖
 * @param {Object} param - 其他字段
 * @param {string} param.module - 模块名
 * @param {string} param.action - 行为
 * @param {Boolean} [immediately = false] immediately - 是否立即上报
 */
export function reportTdbank(param, immediately) {
    AlloyReport.tdbank(assign(defaultTdbankConfig, param), immediately);
}

export default {
    report,
    setReportConfig,
    reportRetCode,
};
